
export class ComponentItems {
  public id: string;
  public componentKey: string;
  public serviceId: string;
}
